import React from "react"
import { observer } from "mobx-react-lite"
import { TextAccordion } from "~components/accordion"
import styled from '~/ui/styled'

const Container = styled.View`
  margin: ${({ theme }) => `${theme.space.sm} 0px`};
`

const PrivacyAndSafety: React.FC = () => {
  return (
    <>
      <Container>
        <TextAccordion
          accordionProps={{
            to: "BlackList",
            label: "黑名单",
            hasRightIcon: true,
          }}
          textProps={{}}
        />
      </Container>
    </>
  )
}

export default observer(PrivacyAndSafety)
